module.exports = __webpack_public_path__ + "static/img/img_t3.bc3498e8.webp";